"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handler_1 = require("./handler");
var msatHandler;
exports.init = function (env, options) {
    // 1. Read the configuration file json
    var xMLHttpRequest = new XMLHttpRequest();
    var domain = window.location.host;
    options = options || { 'configoverwrite': 'N' };
    if (!('configoverwrite' in options)) {
        options.configoverwrite = 'N';
    }
    var _url = getURL(window.location.href, options.configoverwrite);
    xMLHttpRequest.open('GET', _url, false); // `false` makes the request synchronous
    xMLHttpRequest.send(null);
    var config = '';
    if (xMLHttpRequest.status === 200) {
        config = JSON.parse(xMLHttpRequest.responseText);
    }
    else {
        throw new Error('File config not found');
    }
    var cookieConfig = config[domain];
    if (typeof (cookieConfig) === 'undefined') {
        throw new Error('Wrong cookies configuration for this site');
    }
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    // Adding default value for unknown domain behaviour
    var behaviour;
    var package_domain;
    try {
        behaviour = cookieConfig.behavior;
    }
    catch (error) {
        behaviour = 'expressed';
    }
    try {
        package_domain = cookieConfig.package;
    }
    catch (error) {
        package_domain = 'dtccm.marshsat.com';
    }
    var script_url = '//consent.trustarc.com/notice?domain=' + package_domain
        + '&c=teconsent&js=nj&noticeType=bb&pcookie&gtm=1&text=true'
        + '&behavior=' + behaviour;
    if (typeof (cookieConfig.cookie_link) !== 'undefined' && cookieConfig.cookie_link !== '') {
        script_url = script_url + '&cookieLink=' + encodeURI(cookieConfig.cookie_link);
    }
    if (typeof (cookieConfig.privacy_link) !== 'undefined' && cookieConfig.privacy_link !== '') {
        script_url = script_url + '&privacypolicylink=' + encodeURI(cookieConfig.privacy_link);
    }
    if ('undefined' !== typeof (options.locale) && '' !== options.locale) {
        script_url = script_url + '&locale=' + options.locale;
    }
    else if ('undefined' !== typeof (options.language) && '' !== options.language) {
        script_url = script_url + '&language=' + options.language;
    }
    script.src = script_url;
    script.setAttribute('async', 'async');
    script.setAttribute('crossorigin', '');
    head.appendChild(script);
    msatHandler = new handler_1.Handler(cookieConfig, env);
    return msatHandler;
};
function getURL(host, configoverwrite) {
    var url_json = 'msat-cookies-handler-config.json';
    var url_clean = '';
    if (configoverwrite == 'N') {
        document.querySelectorAll('script[src]').forEach(function (sc) {
            var index = sc.src.indexOf('/msat-cookies-handler.min.js');
            if (index > 0) {
                url_clean = sc.src.substring(0, index + 1) + url_json;
            }
        });
    }
    else {
        url_clean = host + configoverwrite;
    }
    return url_clean;
}
self.addEventListener("message", function (e) {
    try {
        if (e.data) {
            var d = JSON.parse(e.data);
            if (d.data && (d.message == 'remove_iframe' || d.message == 'submit_preferences') && d.source == 'preference_manager') {
                msatHandler.apply_consent();
            }
        }
    }
    catch (xx) {
        if (e.data.type == 'webpackOk') {
            msatHandler.apply_consent();
        }
    }
});
